import React, { useState, useContext } from "react";
import { NavLink, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Auth from '../auth/auth';
import { sessionService } from '../../sessionService/storage';
import { AuthContext } from '../../contexts/AuthContext';
import LanguageSelector from "../lang/languageSelector";

const Navbar = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const { user, setUser } = useContext(AuthContext);
    const [toggleVisibilityAuth, setToggleVisibilityAuth] = useState();
    const [formType, setFormType] = useState();
    const path = history.location.pathname;

    const logout = () => {
        setUser(sessionService.destroy());
    }

    const toggleAuth = (formType) => {
        setFormType(formType);
        setToggleVisibilityAuth(!toggleVisibilityAuth);
    }

    return (
        <div className="pointSnaps">
            {path.substring(0, 10) !== "/dashboard" ? <div className="navbar-app container-fluid container-fluid-custom">
                <nav className="navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <NavLink className="navbar-brand" to="/"><img src="/assets/images/logo.png" alt="Username" /><span className="c-white">Point</span><span className="c-white">Snaps</span></NavLink>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="nav navbar-nav ml-auto">
                                {!user ? <li className="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a className="nav-link" onClick={() => toggleAuth('login')}>{t('signIn')}</a>
                                </li> : null}
                                {!user ? <li className="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                    <a className="nav-link btn-link" onClick={() => toggleAuth('register')} >{t('signUp')}</a>
                                </li> : null}
                                {user ?
                                    <li className="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                        <NavLink className="nav-link" activeClassName='activeNavLink' to="/dashboard/folder">{t('dashboard')}</NavLink>
                                    </li> : null}
                                {user ?
                                    <li className="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                        <NavLink to="/" className="nav-link btn-link" onClick={logout} data-toggle="collapse" >{t('logout')}</NavLink>
                                    </li> : null}
                                <li className="nav-link lng-link" >
                                    <span > <i className="fa fa-globe" aria-hidden="true"></i> </span><LanguageSelector  />
                                </li>
                            </ul>

                        </div>
                    </div>
                </nav>
            </div> : null}
            {!user ? <Auth toggleVisibilityAuth={toggleVisibilityAuth} toggleAuth={toggleAuth} formType={formType} /> : null}

        </div >
    );
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/navbarComponent/navbar.js